import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/feature-flags')({
  component: lazyRouteComponent(() => import('./-feature-flags.lazy'), 'default'),
});
